<template>
  <div>
    <div class="comment-top">
      <div class="is-pulled-left">
        <em>{{ comment.profile.name }}</em>
        <span> ({{ comment.profile.profileTypeDisplay }})</span>
      </div>
      <div class="is-pulled-right">{{ comment.created }}</div>
    </div>
    <div class="comment default-comment">
      <p v-html="asHtml(comment.content)">
      </p>
      <div v-if="hasFiles" class="comment-files">
        <documents-component
          :documents="comment.documents">
        </documents-component>
      </div>
    </div>
  </div>
</template>

<script>
  import DocumentsComponent from '@/components/layout/utility/DocumentsComponent'
  import { linkifyComment } from '@/utility/utility_functions'

  export default {
    name: 'comment-component',
    props: {
      comment: {
        type: Object,
        required: true
      }
    },
    methods: {
      asHtml (content) {
        return content.length ? linkifyComment(content) : content
      }
    },
    components: {
      DocumentsComponent
    },
    computed: {
      hasFiles () {
        return this.comment.documents.some(doc => doc.files.length)
      }
    }
  }
</script>
